import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import _ from 'lodash';
import SelectField, { mapListToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty, isValidDateOfBirth } from '../../../shared-components/FormElement/FormElementUtils';
import Col from '../../../shared-components/VXGrid/Col';
import Row from '../../../shared-components/VXGrid/Row';
import './DateOfBirth.less';

const LOCALE_PREFIX = 'GB/components/DateOfBirth/DateOfBirth';

export const isValidBirthday = (
    underAgeMsg,
    errorMsg
) => (value, allValues, props, name) => {
    const year = _.get(allValues, 'personal-info.dobYear');
    const month = _.get(allValues, 'personal-info.dobMonth');
    const day = _.get(allValues, 'personal-info.dobDay');
    const dateValue = `${year}${month}${day}`;
    if (dateValue.length === 8) {
        return isValidDateOfBirth(dateValue, 'YYYYMMDD', underAgeMsg, errorMsg);
    }
};

export class DateOfBirth extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        dayList: PropTypes.array.isRequired,
        monthList: PropTypes.array.isRequired,
        birthYearList: PropTypes.array.isRequired,
        dobDayError: PropTypes.object,
        dobDayField: PropTypes.object,
        dobMonthField: PropTypes.object,
        dobYearField: PropTypes.object
    };

    render() {
        const {
            intl,
            dayList,
            monthList,
            birthYearList,
            dobDayError,
            dobDayField,
            dobMonthField,
            dobYearField
        } = this.props;
        const dobUnderAgeMsg = intl.formatMessage({id: `${LOCALE_PREFIX}.DOB_ERROR`});
        const dobInvalidMessage = intl.formatMessage({id: `${LOCALE_PREFIX}.DATE_INVALID`});
        const dobRequired = intl.formatMessage({id: `${LOCALE_PREFIX}.DOB_REQUIRED`});
        let dobError;
        const isDateFieldActive = _.get(dobDayField, 'active', false)
            || _.get(dobMonthField, 'active', false)
            || _.get(dobYearField, 'active', false);
        if (isDateFieldActive && _.get(dobDayError, 'errorType') && _.get(dobDayError, 'msg')) {
            const id = 'gbDateOfBirth';
            dobError = (
                <div className="help-error-wrapper hasError" id={`${id}-help-error`}>
                    <p className="help-error error-empty open" id={`${id}Format`}>
                        {_.get(dobDayError, 'msg', '')}
                    </p>
                </div>
            );
        }
        return (
            <div className="dob DateOfBirth restricted">
                <fieldset id="dobWrap">
                    <legend><FormattedMessage id={`${LOCALE_PREFIX}.dobLabel`} /></legend>
                    <Row gutterSize={0}>
                        <Col id="dobDayWrapper" xs={4} className="round-left">
                            <Field
                                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.dayLabel`})}
                                id="dobDay"
                                name="dobDay"
                                component={SelectField}
                                optionList={mapListToSelectField(dayList)}
                                required={true}
                                label="DD"
                                validate={[
                                    isEmpty(dobRequired),
                                    isValidBirthday(dobUnderAgeMsg, dobInvalidMessage)
                                ]}
                            />
                        </Col>
                        <Col id="dobMonthWrapper" xs={4}>
                            <Field
                                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.monthLabel`})}
                                id="dobMonth"
                                name="dobMonth"
                                component={SelectField}
                                optionList={mapListToSelectField(monthList)}
                                required={true}
                                label="MM"
                                validate={[
                                    isEmpty(dobRequired),
                                    isValidBirthday(dobUnderAgeMsg, dobInvalidMessage)
                                ]}
                            />
                        </Col>
                        <Col id="dobYearWrapper" xs={4} className="round-right">
                            <Field
                                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.yearLabel`})}
                                id="dobYear"
                                name="dobYear"
                                component={SelectField}
                                optionList={mapListToSelectField(birthYearList)}
                                required={true}
                                label="YYYY"
                                validate={[
                                    isEmpty(dobRequired),
                                    isValidBirthday(dobUnderAgeMsg, dobInvalidMessage)
                                ]}
                            />
                        </Col>
                    </Row>
                </fieldset>
                {dobError}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    // // Grab the properties directly from the message object
    dayList: _.get(state, 'serverData.user.dayList'),
    monthList: _.get(state, 'serverData.user.monthList'),
    birthYearList: _.get(state, 'serverData.user.birthYearList'),
    dobDayField: _.get(state, 'form.ppcreditapply.fields.personal-info.dobDay'),
    dobMonthField: _.get(state, 'form.ppcreditapply.fields.personal-info.dobMonth'),
    dobYearField: _.get(state, 'form.ppcreditapply.fields.personal-info.dobYear'),
    dobDayError: _.get(state, 'form.ppcreditapply.syncErrors.personal-info.dobDay')
});

export default connect(mapStateToProps)(injectIntl(DateOfBirth));
